import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { NEW_API_URL } from "../../../constants/Globals";
import { Pagination } from "react-bootstrap";

function Campaigns({ selNetworkId }) {
  const [loading, setLoading] = useState(true);
  const [campaigns, setCampaigns] = useState([]);
  const [count, setCount] = useState(0);
  const [sortBy, setSortBy] = useState("id");
  const [state, setState] = useState(0);
  const [pageSearch, setPageSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(10);

  useEffect(() => {
    console.log("Campaigns useEffect: selNetworkId", selNetworkId);
    if (selNetworkId) {
      axios
        .get(`${NEW_API_URL}/campaigns`, {
          params: {
            perPage: pageSize,
            pageNumber: pageNumber,
            search: pageSearch,
            formId: "",
          },
        })
        .then(({ data }) => {
          setLoading(false);
          setCampaigns(data.rows);
          setCount(data.count);
        });
    }
  }, [selNetworkId, sortBy, pageSearch, pageNumber, pageSize, state]);

  return (
    <div className="segments">
      <div className="page-headline is-flex">
        <div>
          <strong>Advertising</strong>&nbsp;|&nbsp;Campaigns
        </div>
        <Link to="/campaigns/upsert/0" className="blue-button size-l">
          Create Campaign
        </Link>
      </div>
      <form
        id="search"
        autoComplete="off"
        className="searchForm1 mt-4"
        onSubmit={(e) => this.handleSearchSubmit(e)}
      >
        <input
          onChange={(e) => setPageSearch(e.target.value)}
          type="text"
          className="form-control"
          value={pageSearch}
          name="pageSearch"
          placeholder={"Search for a campaigns"}
        />
      </form>
      <div className="table-filters sorting">
        <div className="table-filters-start">
          <div className="table-sorter">
            <label>Sort by</label>
            <select
              value={sortBy}
              onChange={({ target }) => setSortBy(target.value)}
            >
              <option value="date">Most Recent</option>
              <option value="name">Name</option>
            </select>
          </div>
        </div>

        <div>
          <Pagination size="md" style={{ margin: "0" }}>
            <div className="table-pagination mx-2">{count} Campaigns</div>
            <Pagination.Prev
              style={{ background: "transparent", border: "none" }}
              onClick={() => {
                if (pageNumber > 1) setPageNumber(pageNumber - 1);
              }}
            />
            <span
              className="text-sm-end"
              style={{
                fontSize: "11px",
                lineHeight: "2.5",
                marginRight: "4px",
                marginLeft: "4px",
              }}
            >
              {pageNumber} of {Math.ceil(count / pageSize)}
            </span>
            <Pagination.Next
              style={{ background: "transparent", border: "none" }}
              onClick={() => {
                if (pageNumber < count / pageSize)
                  setPageNumber(pageNumber + 1);
              }}
            />
          </Pagination>
        </div>
      </div>
      <div className="table-wrapper">
        <table
          className="table-body top-border"
          cellSpacing="0"
          cellPadding="0"
        >
          <tbody>
            {loading ? (
              <tr className="table-row">
                <td className="table-cell table-cell-fluid">
                  <em>Loading...</em>
                </td>
              </tr>
            ) : null}

            {!loading && !campaigns.length ? (
              <tr className="table-row">
                <td className="table-cell table-cell-fluid">
                  <em>No campaigns yet...</em>
                </td>
              </tr>
            ) : null}

            {campaigns.map(
              ({
                id,
                title,
                description,
                createdAt,
                updatedAt,
                responseCount,
                responseCountTarget,
                isClosed,
                spend,
                startDate,
                endDate,
              }) => (
                <tr key={id} className="table-row">
                  <td className="table-cell table-cell-fluid">
                    <Link
                      to={`/campaigns/upsert/${id}`}
                      className="text-button inherit-font"
                    >
                      {title}
                    </Link>
                  </td>
                  <td className="table-cell table-cell-labelled" width="150">
                    <div>
                      Created
                      <br />
                      <strong>{moment(createdAt).format("MMM DD, Y")}</strong>
                    </div>
                  </td>
                  <td className="table-cell table-cell-labelled" width="150">
                    <div>
                      Responses
                      <br />
                      <strong>
                        {responseCount ?? 0} / {responseCountTarget}
                      </strong>
                    </div>
                  </td>
                  {/* <td className="table-cell table-cell-labelled" width="150">
                    <div>
                      Spend
                      <br />
                      <strong>
                        {spend ?? 0}
                      </strong>
                    </div>
                  </td> */}
                  {/* <td className="table-cell table-cell-labelled" width="320">
                    <div>
                      Duration
                      <br />
                      <strong>
                        {moment(startDate).format("MM/DD/YY @ hh:mmA")} -{" "}
                        {moment(endDate).format("MM/DD/YY @ hh:mmA")}
                      </strong>
                    </div>
                  </td> */}
                  <td className="table-cell table-action" width="280">
                    <div className="inline-buttons">
                      {isClosed ? (
                        <span className="badge badge-primary">Closed</span>
                      ) : (
                        <>
                          <Link
                            to={`/campaigns/upsert/${id}`}
                            className="blue-button bordered"
                            style={{ marginRight: "8px" }}
                          >
                            Edit
                          </Link>
                          <button
                            className="blue-button bordered"
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want to delete this campaign? This action is permanent and can't be reversed."
                                )
                              ) {
                                axios
                                  .delete(`${NEW_API_URL}/campaigns/${id}`)
                                  .then(() => setState(state * 2))
                                  .then(() => {})
                                  .catch(({ response }) => {
                                    if (response.status === 500) {
                                      alert(
                                        JSON.stringify(response.data.message)
                                      );
                                    }
                                  });
                              }
                            }}
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps)(Campaigns);
